import React, { useEffect, useRef, useState } from "react";
import LoadingAnimation from "../../../../../assets/svg/LoadingAnimation";
import PaperSendIcon from "../../../../../assets/svg/PaperSendIcon";
import dayjs from "@lib/dayjs";
import { sendMessage } from "../../../../../endpoints/candidate.service";
import {
  getJobMessagesList,
  sendJobMessage,
} from "../../../../../endpoints/referral.service";
import { enqueueSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import { updateMessageSeen } from "../../../../../endpoints/job.service";
import { useSelector } from "react-redux";
import { userTypes } from "../../../../../utils/constants";

const ApplicationMessagesTab = ({ applicationDetails }) => {
  const [message, setMessage] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const messagesContainerRef = useRef(null);
  const jobId = applicationDetails?.jobData?.jobId;

  const messagesList = async () => {
    try {
      const { data, success } = await getJobMessagesList(
        jobId,
        applicationDetails.candidateId
      );

      if (success) {
        setMessages(data[0]?.messageData ?? []);
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    messagesList();
  }, []);

  useEffect(() => {
    if (messages.length > 0) {
      markMessagesAsSeen();
    }
  }, [messages]);

  const handleSendMessage = async () => {
    if (!message.trim()) return;
    try {
      setIsLoading(true);
      await sendJobMessage({
        jobId: applicationDetails?.jobData?.jobId,
        message,
        receivedBy: applicationDetails?.candidateId,
      });
      messagesList();
      setMessage("");
      enqueueSnackbar("Message sent successfully", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error + "Error sending message", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const markMessagesAsSeen = async () => {
    if (!messages[0]?.messageData?.length) return;

    const unseenMessageIds = messages[0].messageData
      .filter((msg) => !msg.seen)
      .map((msg) => msg.messageId);

    if (unseenMessageIds.length === 0) return;

    try {
      await updateMessageSeen({ messagesIds: unseenMessageIds });
    } catch (error) {
      console.error("Error marking messages as seen:", error);
    }
  };

  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    if (applicationDetails) {
      if (applicationDetails.candidateId) {
        setSelectedContact({
          id: applicationDetails.candidateId,
          name:
            applicationDetails.jobData?.candidateDetails?.firstName ||
            "Candidate",
        });
      }
    }
  }, [applicationDetails]);

  return (
    <div className="flex flex-1 gap-6 pr-20 overflow-hidden">
      <div className="border-r border-[#ECECEC] w-1/4">
        {applicationDetails?.jobData?.candidateDetails?.firstName && (
          <div
            className={`flex items-center gap-3 py-3 px-4 border-b border-[#ECECEC] cursor-pointer ${
              selectedContact?.id === applicationDetails.candidateId
                ? "bg-[#F1F5F9]"
                : ""
            }`}
            onClick={() => {}}
          >
            <div className="font-montserrat text-white font-semibold uppercase w-9 h-9 rounded-full bg-gray-400 flex items-center justify-center text-xl">
              {applicationDetails?.jobData?.candidateDetails.firstName?.charAt(
                0
              )}
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-charcoal font-medium text-xs">
                {applicationDetails?.jobData?.candidateDetails.firstName}
              </p>
              <p className="text-light-black text-xs">Candidate</p>
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col h-full w-full relative">
        <div
          ref={messagesContainerRef}
          className="flex-grow overflow-y-auto no-scrollbar pr-2 pb-4"
          style={{ maxHeight: "calc(100% - 100px)" }}
        >
          {messages?.length ? (
            messages?.map((item, index) => {
              const isCurrentUser =
                item?.createdBy ===
                (user?.userType === userTypes.RECRUITER
                  ? user?._id
                  : user?.userId);
              // const isSentByCurrentUser = item.createdBy === user._id;
              return (
                <div
                  key={index}
                  className="flex flex-col gap-2 rounded cursor-pointer text-xs border-b p-4"
                >
                  <div
                    className={`rounded text-charcoal flex justify-between font-bold`}
                  >
                    <p className="text-[13px] font-bold text-charcoal">
                      {item.createdName}
                    </p>
                    <p className="text-charcoal font-medium italic">
                      {dayjs(item?.createdAt).format("HH:mm DD/MM/YYYY")}
                    </p>
                  </div>
                  <div className="flex justify-between items-end">
                    <p
                      className={`text-xs font-medium text-light-black py-3 px-5 rounded`}
                    >
                      {item.message}
                    </p>
                    {isCurrentUser && item.seen && (
                      <p className="text-xss text-green-600">Seen</p>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-sm text-center flex h-full items-end justify-center pb-10">
              No messages available.
            </p>
          )}
        </div>

        <div className="mb-10 bg-white left-0 right-0 mx-5">
          <div className="flex border-[#ECECEC] border  gap-4">
            <input
              type="text"
              className="p-4 w-full bg-white rounded text-xs  font-medium focus:border-gray-300 focus:outline-none"
              rows={1}
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <button
              className="text-xs text-charcoal font-medium px-4 flex items-center disabled:cursor-not-allowed"
              // onClick={() => sendMessageApi(message, referralMember._id)}
              onClick={handleSendMessage}
              disabled={isLoading || !message?.trim()}
            >
              {isLoading ? (
                <LoadingAnimation color="black" className={"w-4 h-4"} />
              ) : (
                <PaperSendIcon fill={message?.trim() && "#FF9800"} />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationMessagesTab;
